export const GET_BRAINSTORM_FLOW_WRITERS_SUCCESS = 'GET_BRAINSTORM_FLOW_WRITERS_SUCCESS';

export const CREATE_NEW_BRAINSTORM_SUCCESS = 'CREATE_NEW_BRAINSTORM_SUCCESS';

export const MARK_AS_CREATED = 'MARK_AS_CREATED';
